module.exports = __webpack_public_path__ + "static/media/06-05.3274b394.png";